var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Textarea } from "../../tremor/Textarea";
import { Button } from "../../tremor/Button";
import { Text } from "../../tremor/Text";
import { Card } from "../../tremor/Card";
import { Icon } from "../../tremor/Icon";
import { useEffect, useMemo, useRef, useState } from "react";
import React from "react";
import { useBackend } from "../../layouts/Wrapper";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ErrorBoundary } from "react-error-boundary";
import { ArrowDownTrayIcon, ArrowRightIcon, DocumentChartBarIcon, PencilIcon, PhotoIcon, } from "@heroicons/react/24/outline";
import ChartBase from "../Chart/ChartBase";
import { useDashboard } from "../../layouts/Dashboard/useDashboard";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuIconWrapper, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger, } from "../../tremor/DropdownMenu";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, } from "../../tremor/Accordion";
import { useTheme } from "../../layouts/Dashboard/useTheme";
import { toast } from "sonner";
import { SparklesIcon } from "@heroicons/react/20/solid";
import { ChartPlaceholder } from "../ChartLoader";
dayjs.extend(relativeTime);
export const QuestionMessage = ({ isLast, questionLoading, message, onAdd, onEdit, onReply }) => {
    var _a;
    const { adminMode, containerRef, backend } = useBackend();
    const { dashboard } = useDashboard();
    const theme = useTheme();
    const elementRef = useRef(null);
    const [widget, setWidget] = useState();
    const [cache, setCache] = useState();
    const [editing, setEditing] = useState(false);
    const [newMessage, setNewMessage] = useState("");
    const { role, content, widget: widgetId } = message;
    const getWidget = (id) => __awaiter(void 0, void 0, void 0, function* () {
        let newWidget = yield (backend === null || backend === void 0 ? void 0 : backend.widgets.get(id));
        setWidget(newWidget);
        if (!newWidget || !newWidget.code || newWidget.code.trim() === "")
            return;
        let obj = yield (backend === null || backend === void 0 ? void 0 : backend.widget(id).cache());
        setCache(obj === null || obj === void 0 ? void 0 : obj.data);
    });
    useEffect(() => {
        if (!widgetId)
            return;
        getWidget(widgetId);
    }, [widgetId, isLast, questionLoading]);
    const onDownload = (format) => {
        if (!backend)
            return;
        if (!widgetId)
            return;
        toast.promise(() => {
            return backend.widget(widgetId).export(format, theme);
        }, {
            loading: `Exporting widget as ${format}...`,
            success: (output) => __awaiter(void 0, void 0, void 0, function* () {
                console.log("OUTPUT: ", output);
                try {
                    // Get the file URL, replacing host.docker.internal with localhost if needed
                    const fileUrl = output.url.replace("host.docker.internal", "localhost");
                    // Fetch the file as a blob
                    const response = yield fetch(fileUrl);
                    if (!response.ok)
                        throw new Error('Network response was not ok');
                    // Get the blob from the response
                    const blob = yield response.blob();
                    // Create a blob URL from the blob
                    const blobUrl = window.URL.createObjectURL(blob);
                    // Create a link element
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.download = output.fileName || `export.${format}`; // Set the filename
                    link.style.display = 'none';
                    // Add to document, click and remove
                    document.body.appendChild(link);
                    link.click();
                    // Clean up
                    setTimeout(() => {
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(blobUrl); // Release the blob URL
                    }, 100);
                }
                catch (error) {
                    console.error('Download failed:', error);
                    toast.error('Download failed. Please try again.');
                }
                return "Widget exported";
            }),
            error: (error) => "Error exporting widget: " + error.message,
        });
    };
    if (role === "user") {
        let text = content;
        return (React.createElement("div", { className: "onvo-w-full onvo-flex onvo-flex-col onvo-group onvo-animate-slideLeftAndFade" },
            React.createElement("div", { className: "onvo-question-message-user onvo-rounded-2xl onvo-py-3 onvo-px-4 onvo-bg-black/5 dark:onvo-bg-white/10 onvo-relative onvo-mb-3 onvo-flex onvo-flex-row onvo-items-start onvo-justify-start onvo-gap-3 onvo-self-end " + (editing ? "onvo-w-full" : "onvo-max-w-[80%]") },
                React.createElement("div", { className: "onvo-w-full onvo-max-w-none" },
                    editing ? (React.createElement(Textarea, { className: "!onvo-text-[0.875rem] !onvo-outline-none focus:onvo-outline-none focus:onvo-border-transparent focus:onvo-ring-0 !onvo-p-0 !onvo-leading-[1.5142857rem] !onvo-bg-transparent !onvo-shadow-none onvo-border-none", defaultValue: content, onChange: (e) => setNewMessage(e.target.value) })) : (React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, text) },
                        React.createElement(ReactMarkdown, { className: "onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert ", remarkPlugins: [remarkGfm] }, text))),
                    editing ? (React.createElement("div", { className: "onvo-flex onvo-flex-row onvo-justify-end onvo-items-center onvo-gap-2 onvo-mt-2" },
                        React.createElement(Button, { className: "!onvo-rounded-full", variant: "secondary", color: "gray", onClick: () => {
                                setEditing(false);
                            } }, "Cancel"),
                        React.createElement(Button, { className: " !onvo-rounded-full", onClick: () => {
                                onEdit(newMessage);
                                setEditing(false);
                            } }, "Save"))) : (React.createElement(Icon, { onClick: () => {
                            setEditing(true);
                            setNewMessage(content);
                        }, className: "onvo-absolute onvo-cursor-pointer onvo-top-2 -onvo-left-8 onvo-hidden group-hover:onvo-block", icon: PencilIcon, variant: "shadow", size: "xs" }))))));
    }
    const ImageDownloadEnabled = useMemo(() => {
        var _a;
        if (widget && widget.type === "table")
            return false;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.disable_download_images)
            return false;
        return true;
    }, [dashboard, adminMode, widget]);
    const ReportDownloadEnabled = useMemo(() => {
        var _a;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.disable_download_reports)
            return false;
        return true;
    }, [dashboard, adminMode]);
    const AddToDashboardEnabled = useMemo(() => {
        var _a;
        if (adminMode)
            return true;
        if ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.can_create_widgets)
            return true;
        return false;
    }, [dashboard, adminMode]);
    if (!widget && role === "assistant") {
        let answer = content || "";
        let options = [];
        if (answer.search("<option>") >= 0) {
            let opts = (_a = answer
                .match(/(<option>.*?<\/option>)/g)) === null || _a === void 0 ? void 0 : _a.map((a) => a.replace(/<option>/g, "").replace(/<\/option>/g, ""));
            let ans = answer.split("<option>")[0];
            answer = ans;
            options = opts || [];
        }
        return (React.createElement("article", { className: "onvo-question-assistant-code-wrapper onvo-max-w-none onvo-prose onvo-prose-sm dark:onvo-prose-invert onvo-w-full" },
            answer && answer.trim() !== "" && (React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, answer) },
                React.createElement(ReactMarkdown, { remarkPlugins: [remarkGfm] }, answer))),
            options && options.length > 0 && (React.createElement("div", { className: "onvo-flex onvo-flex-col onvo-items-start onvo-justify-start onvo-gap-2 -onvo-mt-2" }, options.map((a) => (React.createElement("div", { className: "onvo-px-3 onvo-py-2 onvo-flex onvo-flex-row onvo-gap-2 onvo-items-center onvo-cursor-pointer onvo-rounded-2xl onvo-bg-black/5 dark:onvo-bg-white/10 onvo-transition-all hover:onvo-shadow-lg onvo-animate-slideDownAndFade", onClick: () => onReply(a), key: a },
                React.createElement(SparklesIcon, { className: "onvo-size-4 onvo-text-blue-500" }),
                React.createElement(Text, { className: "!onvo-m-0 onvo-flex-grow" }, a),
                isLast && React.createElement(ArrowRightIcon, { className: "onvo-size-4" }))))))));
    }
    return (React.createElement("div", { ref: elementRef, className: "onvo-question-message-assistant onvo-animate-slideRightAndFade onvo-relative onvo-mb-3 onvo-flex onvo-flex-row onvo-items-start onvo-justify-start onvo-gap-3" },
        React.createElement("div", { className: "onvo-w-full" },
            adminMode && (widget === null || widget === void 0 ? void 0 : widget.code.trim()) !== "" && (React.createElement(Accordion, { type: "single", className: "onvo-leading-none onvo-mb-2", collapsible: true },
                React.createElement(AccordionItem, { value: "item-1", className: "onvo-border-b-0" },
                    React.createElement(AccordionTrigger, { className: "onvo-border-b-0 !onvo-py-2 !onvo-px-3 onvo-rounded-2xl onvo-bg-slate-100 dark:onvo-bg-slate-700" },
                        React.createElement("span", null, "Show working")),
                    React.createElement(AccordionContent, { className: "onvo-pt-2" },
                        React.createElement(ErrorBoundary, { fallbackRender: ({ error }) => React.createElement(Text, null, widget === null || widget === void 0 ? void 0 : widget.code) },
                            React.createElement("article", { className: "onvo-question-assistant-code-wrapper onvo-prose onvo-prose-slate onvo-prose-sm dark:onvo-prose-invert onvo-inline onvo-w-full" },
                                React.createElement(ReactMarkdown, { className: "onvo-question-assistant-code !onvo-rounded-2xl -onvo-mt-5" }, "```python\n" + (widget === null || widget === void 0 ? void 0 : widget.code) + "\n```"))))))),
            (cache && widget) ? (React.createElement(Card, { className: "onvo-group onvo-mt-2 onvo-question-assistant-chart onvo-foreground-color onvo-relative onvo-mb-2 onvo-px-0 onvo-py-0 onvo-flex onvo-flex-col" },
                React.createElement("div", { className: "onvo-py-3 onvo-px-2 " +
                        ((widget === null || widget === void 0 ? void 0 : widget.type) === "metric" ? "onvo-h-32" : "onvo-h-96") },
                    React.createElement(ChartBase, { json: cache, title: widget.title })),
                React.createElement("div", { className: "onvo-chart-card-dropdown-wrapper onvo-py-2 onvo-px-2 onvo-z-20 onvo-border-solid onvo-border-t onvo-border-black/5 dark:onvo-border-white/10 onvo-rounded-b-2xl onvo-background-color onvo-flex onvo-w-full onvo-justify-between onvo-flex-row onvo-items-center", onClick: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, onMouseDown: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    }, onMouseUp: (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    } },
                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center" }, adminMode && (React.createElement(Button, { variant: "secondary", onClick: () => onAdd(widget, true) }, "Add to library"))),
                    React.createElement("div", { className: "onvo-flex onvo-gap-2 onvo-items-center" },
                        AddToDashboardEnabled && (React.createElement(Button, { variant: "primary", onClick: () => onAdd(widget, false) }, "Add to dashboard")),
                        (ImageDownloadEnabled || ReportDownloadEnabled) && (React.createElement(DropdownMenu, { modal: false },
                            React.createElement(DropdownMenuTrigger, { asChild: true },
                                React.createElement(Icon, { variant: "shadow", className: "onvo-foreground-color onvo-border-black/10 dark:onvo-border-white/10", icon: ArrowDownTrayIcon })),
                            React.createElement(DropdownMenuContent, { container: containerRef === null || containerRef === void 0 ? void 0 : containerRef.current, className: "onvo-min-w-56 onvo-background-color onvo-border-black/10 dark:onvo-border-white/10" },
                                ReportDownloadEnabled && (React.createElement(React.Fragment, null,
                                    React.createElement(DropdownMenuLabel, null, "Reports"),
                                    React.createElement(DropdownMenuGroup, null,
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("xlsx") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DocumentChartBarIcon, { className: "onvo-size-4" }),
                                                React.createElement("span", null, "Download as excel"))),
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("csv") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DropdownMenuIconWrapper, null,
                                                    React.createElement(DocumentChartBarIcon, { className: "onvo-size-4 onvo-text-inherit" })),
                                                React.createElement("span", null, "Download as CSV")))))),
                                ImageDownloadEnabled && ReportDownloadEnabled && (React.createElement(DropdownMenuSeparator, { className: "onvo-border-black/10 dark:onvo-border-white/10" })),
                                ImageDownloadEnabled && (React.createElement(React.Fragment, null,
                                    React.createElement(DropdownMenuLabel, null, "Images"),
                                    React.createElement(DropdownMenuGroup, null,
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("svg") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(PhotoIcon, { className: "onvo-size-4" }),
                                                React.createElement("span", null, "Download as SVG"))),
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("png") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DropdownMenuIconWrapper, null,
                                                    React.createElement(PhotoIcon, { className: "onvo-size-4 onvo-text-inherit" })),
                                                React.createElement("span", null, "Download as PNG"))),
                                        React.createElement(DropdownMenuItem, { onClick: () => onDownload("jpeg") },
                                            React.createElement("span", { className: "onvo-flex onvo-items-center onvo-gap-x-2" },
                                                React.createElement(DropdownMenuIconWrapper, null,
                                                    React.createElement(PhotoIcon, { className: "onvo-size-4 onvo-text-inherit" })),
                                                React.createElement("span", null, "Download as JPEG"))))))))))))) : (React.createElement(ChartPlaceholder, { className: "onvo-mt-2", title: questionLoading ? "Generating chart..." : undefined, showProgress: questionLoading })))));
};
//# sourceMappingURL=QuestionMessage.js.map